import { useSlotContext } from '../../utils/useSlotContext';
import { IconProps, RemixIcon } from '../Icon/RemixIcon';
import { alertGridAreaIcon } from './constants';

type Props = {
    icon: IconProps['icon'];
};

export const AlertIcon = (props: Props) => {
    const { color, size, icon } = useSlotContext(props, 'icon');

    return (
        <RemixIcon
            color={color}
            icon={icon}
            size={size}
            sx={{
                gridArea: alertGridAreaIcon,
            }}
        />
    );
};
